import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { NewTab, Pencil, Laptop, TextFile, CalendarEmpty } from '@bibliocommons/deprecated-base-icons';

import './FeaturedContentBlock.scss';

class FeaturedContentBlock extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  static renderContentTypeIcon(type) {
    const iconProps = {
      className: 'content-type-icon medium',
      color: '#0081b0'
    };

    switch (type) {
      case 'RESOURCE':
        return <Laptop {...iconProps} />;
      case 'BLOG_POST':
        return <TextFile {...iconProps} />;
      case 'EVENT':
        return <CalendarEmpty {...iconProps} />;
      default:
        return null;
    }
  }

  renderEditLink(content) {
    if (this.props.editable) {
      const location = typeof window !== 'undefined' ? encodeURIComponent(window.location.href) : '';
      return (
        <a href={`/featured_content/edit/${content.get('id')}?previous_location=${location}`}>
          <Pencil />
        </a>
      );
    }

    return null;
  }

  static renderContentTypeHeader(type) {
    const typeSuffix = type === 'RESOURCE' ? 'online_resource' : type.toLowerCase();
    return (
      <div className="content-header">
        {FeaturedContentBlock.renderContentTypeIcon(type)}
        <FormattedMessage id={`section_title_featured_content_${typeSuffix}s`} />
      </div>
    );
  }

  renderContentLink(content, index) {
    const { type } = this.props;
    return (
      <div className="content-link" key={`${type.toLowerCase()}-link-${index}`}>
        <a href={content.get('url')} target="_blank" rel="noopener noreferrer">
          {content.get('title')} <NewTab color={null} />
        </a>
        {this.renderEditLink(content)}
      </div>
    );
  }

  renderContentList() {
    const { list, twoColumns, numContentToShow, type } = this.props;
    const chunkSize = Math.ceil(list.count() / (twoColumns ? 2.0 : 1));
    const visibleList = list.slice(0, numContentToShow);
    let key = 0;
    return Immutable.Range(0, visibleList.count(), chunkSize).map(chunkStart => (
      <div className="content-links" key={`${type.toLowerCase()}-links-${key++}`}>
        {visibleList.slice(chunkStart, chunkStart + chunkSize).map(this.renderContentLink)}
      </div>
    ));
  }

  render() {
    return (
      <div className="cp-featured-content-block">
        <div className="featured-content-card clearfix">
          {FeaturedContentBlock.renderContentTypeHeader(this.props.type)}
          <div className="content-container">{this.renderContentList()}</div>
        </div>
      </div>
    );
  }
}

FeaturedContentBlock.propTypes = {
  type: PropTypes.string.isRequired,
  containerName: PropTypes.string,
  list: ImmutablePropTypes.list.isRequired,
  twoColumns: PropTypes.bool,
  editable: PropTypes.bool,
  numContentToShow: PropTypes.number // Number of links to show
};

FeaturedContentBlock.defaultProps = {
  numContentToShow: 5,
  editable: false
};

export default FeaturedContentBlock;
